<template>
	<div class="addReviewOpinions">
		<div class="recordReview-l">
			<div class="recordReview-l-catalog shadowlaw hlh60">
				<i class="iconfont icon-yijianfankui"></i>
				查看审查意见
			</div>
			<div class="addReviewOpinionsCon shadowlaw">
				<div class="filter filterAddReviewOpinions filterViewReviewOpinions" v-loading="loadingAdvice">
					<el-form
						ref="ruleForm"
						:model="form"
						:rules="rules"
						label-width="110px"
						class="clearfix"
						disabled
					>
						<el-form-item label="对应具体条款">
							<!-- <el-select
								v-model="form.terms"
								placeholder="请选择"
								:popper-append-to-body="false"
							>
								<el-option
									v-for="item in data"
									:key="item.id"
									:label="item.label"
									:value="item.id"
								>
								</el-option>
							</el-select> -->
							<el-input
								v-model.trim="form.terms"
							></el-input>
						</el-form-item>
						<el-form-item label="建议类型">
							<el-select
								v-model="form.type"
								placeholder="请选择"
								:popper-append-to-body="false"
							>
								<el-option
									v-for="item in typeOptions"
									:key="item.code"
									:label="item.brief"
									:value="item.code"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="审查建议内容" class="textareaItem">
							<el-input
								type="textarea"
								:rows="5"
								resize="none"
								placeholder="请输入审查建议内容"
								v-model.trim="form.con"
								:clearable="true"
							></el-input>
						</el-form-item>
						<el-form-item label="依据和理由" class="textareaItem">
							<el-input
								type="textarea"
								:rows="5"
								resize="none"
								placeholder="请输入依据和理由"
								v-model.trim="form.reason"
								:clearable="true"
							></el-input>
						</el-form-item>
					</el-form>
					<div class="operation operationAddReviewOpinions">
						<!-- <a class="new f_transition" @click="delFun('ruleForm')" v-if="curMode=='edit'">
							<!- <i class="iconfont icon-shanchu2"></i> ->
							删除意见
						</a>
						<a class="new f_transition" @click="submitFun('ruleForm')" v-if="curMode=='add'">
							<!- <i class="iconfont icon-tijiao1"></i> ->
							提交意见
						</a>
						<a class="new f_transition" @click="submitFunAmend('ruleForm')" v-if="curMode=='edit'">
							<!- <i class="iconfont icon-tijiao1"></i> ->
							修改意见
						</a>
						<a class="new f_transition" @click="cancaleFun">
							取消
						</a> -->
						<a class="new f_transition" @click="cancaleFun">
							关闭
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:["data","currentKey","curMode"],
	data() {
		return {
			termsOptions: [
				//对应具体条款
				{
					code: "null",
					brief: "全部",
				},
			],
			typeOptions: [
				//建议类型
				{
					code: "修改",
					brief: "修改",
				},
				{
					code: "增加",
					brief: "增加",
				},
				{
					code: "删除",
					brief: "删除",
				},
			],
			form: {
				terms: this.currentKey, //对应具体条款
				type: "修改", //建议类型
				con: "", //审查建议内容
				reason: "", //依据和理由
			},
			rules: {
				con: [
					{
						required: true,
						message: "请输入审查建议内容",
						trigger: "blur",
					},
				],
				reason: [
					{
						required: true,
						message: "请输入依据和理由",
						trigger: "blur",
					},
				],
			},
			loadingAdvice:false,//遮罩
			id:"",//当前意见id
		};
	},
	created() {
	},
	methods: {
		//提交意见
		submitFun(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loadingAdvice=true;
					let formData = new FormData();
					formData.append("item_id",this.form.terms);//对应具体条款的uuid
					formData.append("advise_type",this.form.type); //意见类型
					formData.append("content", this.form.con); //审查建议内容内容
					formData.append("reason", this.form.reason); //理由和依据

					this.axios({
						method: "post",
						url: "/japi/check/check_advices_handle/",
						data: formData
					}).then(res => {
						if (res.data.code == 200) {
							console.log("意见提交成功======");
							console.log(res);
							//遮罩隐藏
							this.loadingAdvice=false;
							this.$message({
								message: "意见提交成功",
								type: "success",
								duration: 3000
							});	
							this.$emit("parentAddReviewOpinionsFun"); //触发父组件中的方法					

						} else if(res.data.code == 500){
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
					});
				} else {
					// console.log('error submit!!');
					return false;
				}
			})
		},
		//修改意见
		submitFunAmend(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loadingAdvice=true;
					let formData = new FormData();
					formData.append("id",this.id);//意见id
					formData.append("item_id",this.form.terms);//对应具体条款的uuid
					formData.append("advise_type",this.form.type); //意见类型
					formData.append("content", this.form.con); //审查建议内容内容
					formData.append("reason", this.form.reason); //理由和依据

					this.axios({
						method: "put",
						url: "/japi/check/check_advices_handle/",
						data: formData
					}).then(res => {
						if (res.data.code == 200) {
							console.log("意见修改成功======");
							console.log(res);
							//遮罩隐藏
							this.loadingAdvice=false;
							this.$message({
								message: "意见修改成功",
								type: "success",
								duration: 3000
							});							
							this.$emit("parentAddReviewOpinionsFun"); //触发父组件中的方法
						} else if(res.data.code == 500){
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
					});
				} else {
					// console.log('error submit!!');
					return false;
				}
			})
		},
		//取消
		cancaleFun() {
			this.$emit("parentAddReviewOpinionsFun"); //触发父组件中的方法
		},
		//删除意见
		delFun(formName){
			this.$refs[formName].validate((valid) => {
				this.loadingAdvice=true;
				if (valid) {
					this.axios({
						method:'delete',
						url:"/japi/check/check_advices_handle/",
						data:{
							id:this.id
						}
					}).then(res =>{
						if (res.data.code == 200) {
							console.log("意见删除成功======");
							console.log(res);
							//遮罩隐藏
							this.loadingAdvice=false;
							this.$message({
								message: "意见删除成功",
								type: "success",
								duration: 3000
							});							
							this.$emit("parentAddReviewOpinionsFun"); //触发父组件中的方法
						} else if(res.data.code == 500){
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
					});
				} else {					
					return false;
				}
			})
		},
		//子组件的方法
		childrenFun(str){
			this.form.reason+=str;
		},
		//查看意见数据
		getDataFun(id){
			this.id=id;//意见id
			this.axios.get('/japi/check/check_advices_handle/?tag=detail&uuid='+id).then(res =>{
				if (res.data.code == 200) {
					console.log("查看意见数据======");
					console.log(res);
					if(res.data.data[0].item_id.indexOf("_")<0){
						this.form.terms="综合意见"; //对应具体条款
					}else{
						this.form.terms=res.data.data[0].item_id__content; //对应具体条款
					}
					this.form.type=res.data.data[0].advise_type; //建议类型
					this.form.con=res.data.data[0].content; //审查建议内容
					this.form.reason=res.data.data[0].reason; //依据和理由
				} else if(res.data.code == 500){
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000
					});
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>